<template>
  <div
    class="fixed bottom-0 w-full border-t border-t-blue-lighter bg-white px-5 lg:hidden"
    v-if="status === 'authenticated'"
  >
    <nav class="mx-auto flex w-full max-w-3xl items-center justify-between">
      <NuxtLink
        v-for="item in navItems"
        :key="item.to"
        :to="item.to"
        class="block fill-[#E6E7E8] p-4 transition-all duration-300 hover:fill-blue"
        :class="{ 'fill-blue': item.activeCondition }"
      >
        <component :is="item.icon" class="size-8" />
      </NuxtLink>
    </nav>
  </div>
</template>

<script setup lang="ts">
const { status } = useAuth()
const route = useRoute()

const navItems = computed(() => [
  { to: '/', icon: 'SvgoNavbarFlash', activeCondition: route.path === '/' },
  { to: '/awards', icon: 'SvgoNavbarBadge', activeCondition: route.path.startsWith('/awards') },
  { to: '/wall-of-fame', icon: 'SvgoNavbarStar', activeCondition: route.path.startsWith('/wall-of-fame') },
  { to: '/profile', icon: 'SvgoNavbarProfile', activeCondition: route.path.includes('/profile') },
])
</script>
